import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditClientComponent } from "./edit-client/edit-client.component";

@Component({
  selector: "app-client-v11",
  templateUrl: "./client-v11.component.html",
  styleUrls: ["./client-v11.component.scss"],
})
export class ClientV11Component extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditClientComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
